<script setup>
import { useAuthStore } from "~/stores/auth";
import { useSettingsStore } from "~/stores/settings";
import { useCookie } from "#app";
import {useCouponStore} from "@stores/coupon";
import Alert from "../base/Alert.vue";

const settingsStore = useSettingsStore();
const couponStore = useCouponStore();

const settings = settingsStore.settings;

const authStore = useAuthStore();

const bonusRegister = () => {
  authStore.modalOpen('register');
  useCookie("code").value = settings.bonus_register
};
const referrerCookie = useCookie("code");
</script>
<template>
  <div class="flex w-full flex-col items-center gap-y-6">
    <!-- Logo -->
    <div class="flex flex-row items-center px-4">
      <div
          class="flex items-center text-2xl font-extrabold tracking-wider text-white subpixel-antialiased"
      >
        {{ settings.general_site_title }}
      </div>
    </div>
    <!-- Call to action -->
    <p class="flex text-center text-lg font-bold">
      Tem certeza de que deseja cancelar seu registro?
    </p>
    <p class="flex text-center" v-if="referrerCookie || couponStore.couponText">
        <p v-if="couponStore.couponText">
          <span class="text-brand-primary">
            {{ couponStore.couponText }}
          </span>
          em bônus esperam por você.
        </p>
        <p v-else>
          Bônus Incríveis esperam por você.
        </p>
    </p>
    <BaseButton class="w-full" variant="primary" @click="bonusRegister" >
      <p>Continuar</p>
    </BaseButton>

    <button class="text-sm" @click="authStore.modalClose()">
      Sim, quero cancelar
    </button>
  </div>
</template>